var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbicacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 12,
    fill: "#4D4D4D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.165 11.835C17.165 14.37 13.93 18.25 12.34 19.57C11.935 19.905 11.35 19.895 10.955 19.545C9.46 18.205 6.5 14.355 6.5 11.835C6.5 8.61 8.61 6.5 11.835 6.5C15.06 6.5 17.17 8.61 17.17 11.835H17.165Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8351 14.395C13.6797 14.395 15.1751 12.8996 15.1751 11.055C15.1751 9.21033 13.6797 7.71497 11.8351 7.71497C9.99049 7.71497 8.49512 9.21033 8.49512 11.055C8.49512 12.8996 9.99049 14.395 11.8351 14.395Z",
    fill: "#D2D2D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbicacion);
export default __webpack_public_path__ + "static/media/Ubicacion.6ffce140e1ec4f19e517655604271aed.svg";
export { ForwardRef as ReactComponent };